// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"4d341a85","198":"f540f5fa","787":"54798639"}[chunkId] + ".chunk.js";
};